import styled from '@emotion/styled'
import { Col } from 'react-bootstrap'

export const feeDetail = styled.div`
  label: feeDetail;
  padding-left: 24px;
  padding-top: 6px;
  padding-bottom: 6px;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
`

export const SmallerSubText = styled.span`
  label: SmallerSubText;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '14px' : '16px')};
  color: ${(props) => props.theme.colors.grey2};
`

export const LineTitles = styled(Col)`
  label: LineTitles;
  color: ${(props) => props.theme.colors.grey2};
`

export const AnnualRenewalFootnote = styled.span`
  label: AnnualRenewalFootnote;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: 16px;
`

export const DisclaimerDiv = styled.div`
  label: DisclaimerDiv;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '16px')};
`
